import { ButtonBase, styled } from '@mui/material';

type ButtonContainerProps = {
  variant: 'outlined' | 'contained' | 'text';
  rounded: boolean;
  isRedButton: boolean;
};

export const ButtonContainer = styled(ButtonBase)<ButtonContainerProps>(
  ({ variant, rounded, isRedButton, theme }) => {
    const mainColor = isRedButton ? '#FF4C4C' : theme.palette.secondary.main;

    const variants = {
      contained: {
        border: `1px solid ${mainColor}`,
        background: mainColor,
        color: theme.palette.common.white,

        '&:hover': {
          opacity: 0.8,
        },

        '&:disabled': {
          cursor: 'not-allowed',
          background: '#D0D5DD',
          color: '#98A2B3',
          border: `1px solid #D0D5DD`,
        },
      },

      outlined: {
        border: `1px solid ${mainColor}`,
        background: 'transparent',
        color: mainColor,

        '&:hover': {
          background: mainColor,
          color: theme.palette.common.white,
        },

        '&:disabled': {
          cursor: 'not-allowed',
          borderColor: '#D0D5DD',
          color: '#98A2B3',
          background: 'transparent',
        },
      },

      text: {
        border: 'none',
        background: 'transparent',
        color: mainColor,
        padding: '8px 12px',

        '&:hover': {
          // textDecoration: 'underline',
          // textUnderlineOffset: '2px',
          // display: 'inline-flex',
          opacity: 0.8,
          transition: '0.3s',
          background: '#98A2B333',
          borderRadius: 999,
        },

        '&:disabled': {
          cursor: 'not-allowed',
          color: '#98A2B3',
        },
      },
    };

    return {
      borderRadius: rounded ? '999px' : '4px',

      padding: '8px 24px',

      fontWeight: 'bold',
      fontSize: '14px',
      cursor: 'pointer',

      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      lineHeight: '140%',
      fontFamily: 'Montserrat',
      textAlign: 'center',
      gap: '4px',

      transition: '0.3s',

      '& .arrow-forward-ios': {
        fontSize: 12,
      },

      ...variants[variant],
    };
  }
);
